/**
 * Camadas React vivendo fora da árvore de um `b-modal`: o root montado pelos
 * wrappers (`*React.vue`) e os portais do Radix/DS (Dialog, Select, DatePicker),
 * todos com a classe `react-app-root`.
 *
 * Servem ao `ignore-enforce-focus-selector` do `b-modal`. Sem isso, abrir um
 * modal React POR CIMA de um b-modal aberto (Gerar conta a pagar no extrato do
 * Repasse, entrada de estoque) trava a aba: ao focar qualquer campo do modal
 * React, o `enforceFocus` do b-modal puxa o foco de volta para si (o alvo está
 * fora do seu conteúdo) e o FocusScope do Radix devolve para o campo — um
 * ping-pong infinito de `focusin`, que aparece para o usuário como "a página
 * não responde" e impede editar qualquer campo (card 86ak1qj0q).
 */
export const REACT_LAYER_SELECTORS = [
  '.react-app-root',
  '[data-radix-popper-content-wrapper]'
]
